import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Icon } from '../Icon';
import styles from './LinksList.module.css';
const ICON_KEYWORDS_MAPPING = {
    information: ['suporte', 'sistemas', 'support', 'system', 'help', 'ajuda'],
    chat: ['central', 'soluções', 'solutions', 'chat', 'contact', 'contato'],
    fileContract: ['declaração', 'privacidade', 'privacy', 'policy', 'política'],
    document: ['termos', 'uso', 'terms', 'use', 'agreement', 'acordo'],
};
export const LinksList = ({ title, links, className = '', 'data-testid': dataTestId }) => {
    const getIconForLink = (link) => {
        if (link.icon) {
            return link.icon;
        }
        const labelLower = link.label.toLowerCase();
        for (const [iconName, keywords] of Object.entries(ICON_KEYWORDS_MAPPING)) {
            if (keywords.some(keyword => labelLower.includes(keyword))) {
                return _jsx(Icon, { name: iconName, alt: `${link.label} icon` });
            }
        }
        return _jsx(Icon, { name: 'question', alt: `${link.label} icon` });
    };
    const renderLink = (link, index) => {
        const commonContent = (_jsxs(_Fragment, { children: [_jsx("div", { className: styles.linkIcon, "data-testid": `${dataTestId || 'links-list'}-icon-${index}`, children: link.icon || getIconForLink(link) }), _jsx("h3", { className: styles.linkLabel, "data-testid": `${dataTestId || 'links-list'}-label-${index}`, children: link.label })] }));
        if (link.onClick) {
            return (_jsx("button", { type: 'button', onClick: link.onClick, className: `${styles.linkItem} ${styles.linkItemButton}`, "data-testid": `${dataTestId || 'links-list'}-item-${index}`, children: commonContent }, link.id));
        }
        return (_jsx("a", { href: link.href, target: link.target ?? '_self', rel: link.target === '_blank' ? 'noopener noreferrer' : undefined, className: styles.linkItem, "data-testid": `${dataTestId || 'links-list'}-item-${index}`, children: commonContent }, link.id));
    };
    return (_jsxs("section", { className: `${styles.container} ${className}`, "data-testid": dataTestId || 'links-list', children: [_jsx("h2", { className: styles.title, "data-testid": `${dataTestId || 'links-list'}-title`, children: title }), _jsx("div", { className: styles.linksGrid, "data-testid": `${dataTestId || 'links-list'}-grid`, children: links.map((link, index) => renderLink(link, index)) })] }));
};
